import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getQueryParams } from '@pin-up-global/common';
import { ApiService } from '@shared/abstraction';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import {
  BlocksDefinitionsReq,
  BlocksDefinitionsRes,
  Flow,
  FlowContent,
  FlowContentReq,
  FlowReq,
} from './flow.abstraction';

@Injectable({
  providedIn: 'root',
})
export class FlowApiService extends ApiService {
  isLoading$ = this._isLoading$;

  getFlow(params: FlowReq): Observable<Flow> {
    return this._httpClient.get<Flow>(
        `@api/settings/flows/flows/${ params.flowId }/`,
    ).pipe(
        manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }

  updateFlow(params: FlowReq, body: Partial<Pick<Flow, 'name' | 'isActive' | 'triggers'>>): Observable<Flow> {
    return this._httpClient.patch<Flow>(
        `@api/settings/flows/flows/${ params.flowId }/`,
        body,
    ).pipe(
        manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }

  getFlowContent(params: FlowContentReq): Observable<FlowContent> {
    return this._httpClient.get<FlowContent>(
        `@api/settings/flows/flow-contents/${ params.flowContentId }/`,
    ).pipe(
        manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }

  updateFlowContent(params: FlowContentReq, body: Pick<FlowContent, 'data'>): Observable<FlowContent> {
    return this._httpClient.patch<FlowContent>(
        `@api/settings/flows/flow-contents/${ params.flowContentId }/`,
        body,
    ).pipe(
        manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }

  getBlocksDefinitions(params: BlocksDefinitionsReq): Observable<BlocksDefinitionsRes> {
    return this._httpClient.get<BlocksDefinitionsRes>(
        '@api/settings/flows/definitions/',
        { params: getQueryParams(params) },
    ).pipe(
        manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }
}
